import { CaptureFlow } from '@/components/capture/CaptureFlow';

export function CaptureRoute() {
  return <CaptureFlow />;
}
